import React, { useEffect } from 'react';
import {
  StyledContentHeader,
  StyledCoverageDetailWrapper,
  StyledTableCard,
  StyledTableHeader,
  StyledTableIndexHeader,
  StyledTableTitle,
} from '@src/pages/workflow/components/Validation/Flow/styled';
import BaseTable from '@components/common/BaseTable';
import { Form, Select, Tooltip } from 'antd';
import { bankRound } from '@src/emp-3.0/utils/number';
import { EventType, getEventConfigByType } from './utils';

interface IProps {
  tableData: {};
  onDimensionChange?: (dimension: any) => void;
  dimensions: any[];
  eventTypes: EventType[];
}
const CoverageDetail: React.FC<IProps> = ({
  tableData,
  onDimensionChange,
  dimensions,
  eventTypes,
}) => {
  const items = Object.keys(tableData);
  const [dimension, setDimension] = React.useState<any>(null);


  useEffect(() => {
    if (dimensions.length) {
      if (!dimension) {
        // set default dimension
        setDimension(dimensions[0]);
      }
    }
  }, [dimensions]);

  useEffect(() => {
    if (dimension) {
      onDimensionChange?.(dimension);
    }
  }, [dimension, onDimensionChange]);

  const dimensionKey = dimension?.dimension_name;

  const columns = [
    {
      key: dimensionKey,
      dataKey: dimensionKey,
      title: '',
      width: '50%',
      headerWithPadding: true,
      sortEnabled: false,
      align: 'left',
      headerRenderer: () => {
        return <StyledTableIndexHeader>{dimension?.display_name}</StyledTableIndexHeader>;
      },
      cellRenderer: ({ cellData }) => {
        return <div>{cellData}</div>;
      },
    },
    ...eventTypes.map((type) => {
      const { label, field } = getEventConfigByType(type);
      return {
        title: label + ' %',
        headerRenderer: () => (
          <StyledTableHeader>
            <Tooltip
              title={`The total ${label}s based on the mapping rule divided by the total reported events for this dimension value.`}
            >
              {label} %
            </Tooltip>
          </StyledTableHeader>
        ),
        dataKey: field,
        key: field,
        align: 'right',
        width: '25%',
        cellRenderer: ({ cellData }) => {
          if (cellData === undefined) {
            return '--';
          }
          const num = cellData || 0;
          const res = bankRound(num * 100, 3);
          return <span style={{ color: res === 0 ? '#FA8C16' : '#000' }}>{res}%</span>;
        },
      };
    }),
  ];

  return (
    <StyledCoverageDetailWrapper>
      <StyledContentHeader>
        <span>Platform by</span>
        <Select
          value={dimensionKey}
          bordered={false}
          options={dimensions}
          style={{ minWidth: '100px' }}
          dropdownStyle={{ minWidth: '300px' }}
          onSelect={(value, option) => {
            setDimension(option);
          }}
          fieldNames={{ label: 'display_name', value: 'dimension_name' }}
        />
      </StyledContentHeader>
      <div>
        {items.map((item) => {
          const rowHeight = 50;
          const headerHeight = 35;
          const padding = 25;
          const tableHeight = tableData[item].length * rowHeight + headerHeight + padding;
          return (
            <StyledTableCard as={'div'} key={item}>
              <StyledTableTitle>{item}</StyledTableTitle>
              <div style={{ width: '100%', height: `${tableHeight}px` }}>
                <BaseTable columns={columns} data={tableData[item]} />
              </div>
            </StyledTableCard>
          );
        })}
      </div>
    </StyledCoverageDetailWrapper>
  );
};

export default CoverageDetail;
